import {Component, OnInit, ChangeDetectionStrategy, ViewChild, ElementRef, Input, ChangeDetectorRef} from '@angular/core';
import {LocalisationService} from '../../../services/localisation.service';
import {CalculationsViewModel} from '../../../viewModels/calculations.viewModel';
import {ThemeService} from '../../../services/theme.service';

interface IBreakdown {
    title: string;
    image: string;
    nutrients: number;
    description: string;
}

@Component({
    selector: 'app-nutrients-breakdown',
    templateUrl: './nutrients-breakdown.component.html',
    styleUrls: ['./nutrients-breakdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NutrientsBreakdownComponent implements OnInit {
    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;

    @Input() calculations: CalculationsViewModel;
    @Input() horizontal = false;

    breakdowns: IBreakdown[];

    constructor(
        public readonly themeService: ThemeService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly localisationService: LocalisationService) {
    }

    ngOnInit() {
        this.initBreakdowns();
    }

    private getSvg(svg: string): string {
        if (this.themeService.getCurrentTheme() !== 'light') {
            svg += '-white';
        }

        return `assets/images/macros/${svg}.svg`;
    }

    private initBreakdowns(): void {
        this.breakdowns = [
            {
                title: `${this.localisationService.localise('calories')}`,
                image: this.getSvg('cal'),
                nutrients: Math.floor(this.calculations.calories),
                description: `kcal`
            },
            {
                title: `${this.localisationService.localise('proteins')}`,
                image: this.getSvg('protein'),
                nutrients: Math.floor(this.calculations.protein),
                description: `${this.localisationService.localise('abbreviation_gram')}`
            },
            {
                title: `${this.localisationService.localise('carbs')}`,
                image: this.getSvg('carbs'),
                nutrients: Math.floor(this.calculations.carbs),
                description: `${this.localisationService.localise('abbreviation_gram')}`
            },
            {
                title: `${this.localisationService.localise('fats')}`,
                image: this.getSvg('fats'),
                nutrients: Math.floor(this.calculations.fat),
                description: `${this.localisationService.localise('abbreviation_gram')}`
            }
        ];
    }
}
